import React from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import ItemProject from "./ItemProject";

const Project = () => {
  AOS.init();
  const dataProject = [
    {
      image: "/devhouse.png",
      title: "DH Shop",
      design: "Duc Hai Dev",
      development: "Duc Hai Dev",
      description:
        "My platform is an e-commerce space where users can register and sell code snippets, designs, and more.",
      tags: ["Reactjs", "Nodejs", "Tailwindcss", "SQL", "Docker"],
      link: "/",
      time: "06/2023 - present",
    },

    {
      image: "/dhblogging.png",
      title: "DH Blogging",
      design: "Duc Hai Dev",
      development: "Duc Hai Dev",
      description:
        "My website is a platform dedicated to sharing articles, experiences, roadmaps, and source code.",
      tags: ["React", "Redux", "Tailwindcss", "Firebase"],
      link: "https://duchaidev.vercel.app",
      time: "03/2023 - 5/2023",
    },
    {
      image: "/thecao.png",
      title: "Scratch Card",
      design: "Duc Hai Dev",
      development: "Duc Hai Dev",
      description:
        "Optimized Scratch Card Website Interface for a Seamless Display Across All Devices",
      tags: ["HTML", "CSS", "Javascript"],
      link: "https://duchaidev.github.io/ProjectWebTheCao/index.html",
      time: "11/2022 - 12/2022",
    },
  ];
  return (
    <section
      className=" mt-[150px] py-[5%] px-[3%] flex items-center justify-center gap-[60px] flex-col"
      id="project"
    >
      <h2
        className="font-extrabold text-[70px] sm:text-[90px] bg-gradient-to-r from-[#00ff85] to-[#00dbff] text-transparent bg-clip-text"
        data-aos="fade-down"
        data-aos-duration="600"
      >
        My Project
      </h2>
      <div
        className=" grid xl:grid-cols-3 lg:grid-cols-2 col-span-1 gap-[2%] "
        data-aos="fade-right"
      >
        {dataProject?.length > 0 &&
          dataProject?.map((item, index) => (
            <ItemProject
              image={item?.image}
              title={item?.title}
              key={index}
              design={item?.design}
              development={item?.development}
              tags={item?.tags}
              link={item?.link}
              description={item?.description}
              time={item?.time}
            ></ItemProject>
          ))}
      </div>
    </section>
  );
};

export default Project;
